import { AGGREGATOR_BASE_URL, CENTRAL_HUB_BASE_URL } from 'src/environments/base-url';

export const operatorRegionsUrl = (): string => `${CENTRAL_HUB_BASE_URL}/regions`;

export const aggregatorRegionsUrl = (): string => `${AGGREGATOR_BASE_URL}/regions`;
